export const ActivedLenguages = {
    es: true,
    en: true,
    gl: true,
    ca: true,
    eu: true,
    va: true,
  };